import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ReportViewState } from "./model";
import { EmbedConfig } from "../../../utils/types/EmbedConfig";
import { IPayloadSetError } from "../../../store/Interfaces";
import { Signal } from "../../../utils/interfaces/store/IStore";

const initialState: ReportViewState = {
  embedConfig: Signal.default(),
};

export const ReportViewSlice = createSlice({
  name: "reportView",
  initialState,
  reducers: {
    clean: (_, action: PayloadAction<undefined>) => {
      return {
        ...initialState,
        action: { ...action } as any,
      } as ReportViewState;
    },
    getEmbedConfig: (state, action: PayloadAction<undefined>) => {
      return {
        ...state,
        action: { ...action } as any,
        embedConfig: Signal.loading(),
      } as ReportViewState;
    },
    getEmbedConfigSuccess: (
      state,
      action: PayloadAction<EmbedConfig>
    ) => {
      return {
        ...state,
        action: { ...action } as any,
        embedConfig: Signal.success(action.payload),
      } as ReportViewState;
    },
    getEmbedConfigError: (state, action: PayloadAction<IPayloadSetError>) => {
      return {
        ...state,
        action: { ...action } as any,
        embedConfig: Signal.error(
          action.payload.error,
          action.payload.shorterror
        ),
      } as ReportViewState;
    },
  },
});
